const buildFAQlist = (
    location,
    licensingInfo,
    getAvailibleQuestions,
    selectedPeriod,
    isSecure = false,
) => {
    const { pathname } = location;
    const defaultQuestions = getAvailibleQuestions(licensingInfo, selectedPeriod, isSecure);
    return defaultQuestions.filter(item => item.accessiblePages.includes(pathname));
};

export default buildFAQlist;
